import { render, staticRenderFns } from "./FactorClassDisplay.vue?vue&type=template&id=7801b9d8&scoped=true&"
import script from "./FactorClassDisplay.vue?vue&type=script&lang=ts&"
export * from "./FactorClassDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./FactorClassDisplay.vue?vue&type=style&index=0&id=7801b9d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7801b9d8",
  null
  
)

export default component.exports